export const maskRut = (value: string): string => {
    // Keep only RUT body + DV (digit or K). Strip spaces/special chars first.
    const cleaned = value.replace(/[^0-9kK]+/g, '')

    if (cleaned.length >= 9) {
        return cleaned
            .replace(/(\w{2})(\w{3})/, '$1.$2')
            .replace(/(\w{3})(\w)/, '$1.$2')
            .replace(/(\w{3})(\w{1,2})/, '$1-$2')
            .replace(/(-\w{1})\w+?$/, '$1')
    }

    return cleaned
        .replace(/(\w{1})(\w{3})/, '$1.$2')
        .replace(/(\w{3})(\w)/, '$1.$2')
        .replace(/(\w{3})(\w{1,2})/, '$1-$2')
        .replace(/(-\w{1})\w+?$/, '$1')
}
